module.exports = __webpack_public_path__ + "static/media/audioguia_small.32c49f48.svg";